module.exports = __webpack_public_path__ + "media/images/logo-7a140d2b93dcfe78ea8bf603bca9eade.svg";